var map = {
	"./animation-collection.png": 21,
	"./create-color-palette.png": 22,
	"./draw-collection.png": 23,
	"./gymidle.png": 24,
	"./longhairguy.jpeg": 25,
	"./longhairguy.png": 26,
	"./longhairguy4x3.png": 27,
	"./my-to-do-list.png": 28,
	"./page-collection.png": 29,
	"./phoneidle.png": 30,
	"./poor-portfolio.png": 31,
	"./visual-animation.png": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;